<template>
  <div class="ma-n5">
    <div class="d-flex flex-column align-center justify-center dashboard-container">
      <div class="dashboard-wrapper mt-8">
        <h3 class="dashboard-title mb-6">
          Sample Submittal Form
        </h3>

        <div class="step-card mb-6">
          <div class="step-header">
            <div class="step-number">1</div>
            <h4 class="step-title">Download Form</h4>
          </div>
          <div class="step-content">
            <p class="intro-text">
              On this page you will find the forms needed to submit any type of sample you would like to have tested.
              A brief explanation of the tests we perform is available
              <a href="/pdfs/IDFL_DF_-_Brief_Explanation_of_Tests_A4.pdf" target="_blank" class="pdf-link">here</a>.
            </p>

            <ul class="form-list">
              <li>
                <strong>Client Agreement:</strong>
                <a href="/pdfs/IDFL-Client-Agreement-en.pdf" target="_blank" class="pdf-link">English</a> |
                <a href="/pdfs/IDFL_Client_Agreement_ENCN.pdf" target="_blank" class="pdf-link">Chinese (simplified)</a> |
                <a href="/pdfs/IDFL_Client_Agreement_ENJP.pdf" target="_blank" class="pdf-link">Japanese</a> |
                <a href="/pdfs/IDFL_Client_Agreement_EN_KR.pdf" target="_blank" class="pdf-link">Korean</a>
              </li>

              <li>
                <strong>Detailed Client Information:</strong>
                <a href="/pdfs/IDFL-Submittal-Form-Detailed-Client-Info.pdf" target="_blank" class="pdf-link">English</a> |
                <a href="/pdfs/IDFL_Detailed_Client_Info_CN.pdf" target="_blank" class="pdf-link">Chinese (simplified)</a>
              </li>

              <li>
                <strong>Down and Feathers:</strong>
                <a href="/pdfs/IDFL-Submittal-Form-Down-and-Feathers-2024-2.pdf" target="_blank" class="pdf-link">English</a> |
                <a href="/pdfs/IDFL-Submittal-Form-Down-and-Feathers-2024-EN-CN.pdf" target="_blank" class="pdf-link">Chinese (simplified)</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Down_Feathers_ENCT.pdf" target="_blank" class="pdf-link">Chinese (traditional)</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Down_Feathers_ENJP.pdf" target="_blank" class="pdf-link">Japanese</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Down_Feathers_ENKR.pdf" target="_blank" class="pdf-link">Korean</a>
              </li>

              <li>
                <strong>Downproof/fillproof:</strong>
                <a href="/pdfs/IDFL_Submittal_Form_-_Downproof__Fillproof.pdf" target="_blank" class="pdf-link">English</a> |
                <a href="/pdfs/IDFL-Submittal-Form-Downproof-Fillproof-ENCN.pdf" target="_blank" class="pdf-link">Chinese (simplified)</a> |
                <a href="/pdfs/IDFL-Submittal-Form-Downproof-Fillproof-ENCT.pdf" target="_blank" class="pdf-link">Chinese (traditional)</a> |
                <a href="/pdfs/IDFL-Submittal-Form-Downproof-Fillproof-EN-JP.pdf" target="_blank" class="pdf-link">Japanese</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Downproof__Fillproof_ENKR.pdf" target="_blank" class="pdf-link">Korean</a>
              </li>

              <li>
                <strong>DWR and Other Treatments:</strong>
                <a href="/pdfs/IDFL-Submittal-Form-DWR-Other-Treatments.pdf" target="_blank" class="pdf-link">English</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_DWR__Other_Treatments_ENCN.pdf" target="_blank" class="pdf-link">Chinese (simplified)</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_DWR__Other_Treatments_ENCT.pdf" target="_blank" class="pdf-link">Chinese (traditional)</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_DWR__Other_Treatments_ENKR.pdf" target="_blank" class="pdf-link">Korean</a>
              </li>

              <li>
                <strong>Isotope Origin:</strong>
                <a href="/pdfs/IDFL-Submittal-Form-Isotope-Origin.pdf" target="_blank" class="pdf-link">English</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Isotope_Origin_ENCN.pdf" target="_blank" class="pdf-link">Chinese (simplified)</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Isotope_Origin_EN_JP.pdf" target="_blank" class="pdf-link">Japanese</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Isotope_Origin_ENKR.pdf" target="_blank" class="pdf-link">Korean</a>
              </li>

              <li>
                <strong>Synthetic and Other Fills:</strong>
                <a href="/pdfs/IDFL_Sample_Submittal_Form__SYNTHETIC__FILLS_v.2019.pdf" target="_blank" class="pdf-link">English</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Synthetic__Other_Fills_ENCN.pdf" target="_blank" class="pdf-link">Chinese (simplified)</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Synthetic__Other_Fills_ENJP.pdf" target="_blank" class="pdf-link">Japanese</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Synthetic__Other_Fills_ENKR.pdf" target="_blank" class="pdf-link">Korean</a>
              </li>

              <li>
                <strong>Textiles:</strong>
                <a href="/pdfs/IDFL-Submittal-Form-Textiles.pdf" target="_blank" class="pdf-link">English</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Textiles_ENCN.pdf" target="_blank" class="pdf-link">Chinese (simplified)</a> |
                <a href="/pdfs/IDFL-Submittal-Form-Textiles-ENJP.pdf" target="_blank" class="pdf-link">Japanese</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Textiles_ENKR.pdf" target="_blank" class="pdf-link">Korean</a>
              </li>

              <li>
                <strong>Thermal Testing:</strong>
                <a href="/pdfs/IDFL_Submittal_Form_-_Thermal_Testing_06_2018.pdf" target="_blank" class="pdf-link">English</a>
              </li>

              <li>
                <strong>IDFL Healthy Down and Filling Program:</strong>
                <a href="/pdfs/IDFL_Healthy_Filling_SSF_-_2019_EN_4OhK5uk.pdf" target="_blank" class="pdf-link">English</a> |
                <a href="/pdfs/IDFL_Submittal_Form_-_Healthy_Filling_Program_2019_ENCN.pdf" target="_blank" class="pdf-link">Chinese (simplified)</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="step-card mb-6">
          <div class="step-header">
            <div class="step-number">2</div>
            <h4 class="step-title">Select Testing Location</h4>
          </div>
          <div class="step-content">
            <p class="mb-3">Choose where you would like your sample form to be sent.</p>
            <v-select
              v-model="selectedLocation"
              :items="testingLocations"
              item-text="name"
              item-value="id"
              label="Select Testing Location"
              outlined
              :loading="loadingLocations"
              hide-details
            ></v-select>
          </div>
        </div>

        <div class="step-card mb-6">
          <div class="step-header">
            <div class="step-number">3</div>
            <h4 class="step-title">Package Tracking Information</h4>
          </div>
          <div class="step-content">
            <p class="mb-3">If your samples are being shipped, please provide the carrier tracking number below.
                            If not yet available, enter "Not Available".</p>
            <v-text-field
              v-model="trackingInformation"
              label="Tracking Information"
              outlined
              hide-details
              placeholder="Enter tracking information..."
              clearable
            ></v-text-field>
          </div>
        </div>

        <div class="step-card mb-6">
          <div class="step-header">
            <div class="step-number">4</div>
            <h4 class="step-title">Additional Notes (Optional)</h4>
          </div>
          <div class="step-content">
            <p class="mb-3">Special Instructions, Additional Testing Information, Any other notes for the lab.</p>
            <v-text-field
              v-model="additionalInformation"
              label="Additional Information"
              outlined
              hide-details
              placeholder="Enter additional information..."
              clearable
            ></v-text-field>
          </div>
        </div>

        <div class="step-card mb-6">
          <div class="step-header">
            <div class="step-number">5</div>
            <h4 class="step-title">Upload Completed Form</h4>
          </div>
          <div class="step-content">
            <p class="mb-3">Upload your completed and signed form (PDF format only).</p>
            <v-file-input
              v-model="selectedFile"
              label="Choose PDF file"
              accept=".pdf"
              outlined
              hide-details
              prepend-icon=""
              :clearable="true"
            >
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-file-pdf-box</v-icon>
              </template>
            </v-file-input>
          </div>
        </div>

        <div class="text-center mt-8">
          <v-btn
            color="primary"
            x-large
            :disabled="!selectedFile || !selectedLocation || !trackingInformation"
            :loading="uploading"
            @click="uploadPdf"
            class="submit-btn"
          >
            <v-icon left>mdi-upload</v-icon>
            Submit Form
          </v-btn>
          <p v-if="!selectedLocation || !selectedFile || !trackingInformation" class="mt-3 helper-text">
            Please complete all the required steps above to submit your form
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      selectedFile: null,
      selectedLocation: null,
      testingLocations: [],
      loadingLocations: false,
      uploading: false,
      trackingInformation: null,
    };
  },
  methods: {
    async fetchTestingLocations() {
      this.loadingLocations = true;
      try {
        const response = await window.axios.get('sample_workbench/api/testing-locations/');
        this.testingLocations = response.data;
      } catch (error) {
        this.$toast.error('Failed to load testing locations');
      } finally {
        this.loadingLocations = false;
      }
    },
    async uploadPdf() {
      this.uploading = true;
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('testing_location', this.selectedLocation);
      formData.append('additional_information', this.additionalInformation);
      formData.append('tracking_information', this.trackingInformation);

      try {
        await window.axios.post('sample_workbench/api/upload-pdf/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        this.$toast.success('PDF submitted successfully!');
        this.selectedFile = null;
        this.selectedLocation = null;
        this.additionalInformation = null;
        this.trackingInformation = null;
      } catch (error) {
        this.$toast.error('Upload failed. Please try again.');
      } finally {
        this.uploading = false;
      }
    },
  },
  mounted() {
    this.fetchTestingLocations();
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    box-sizing: border-box;
    padding: 20px 20px 60px 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
  }
  &-title {
    color: #0060af;
    font-weight: 600;
    font-size: 28px;
  }
  &-wrapper {
    max-width: 1200px;
  }
}

.step-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
}

.step-header {
  background: linear-gradient(135deg, #0060af 0%, #0080d6 100%);
  padding: 20px 30px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.step-number {
  background-color: white;
  color: #0060af;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
  flex-shrink: 0;
}

.step-title {
  color: white;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.step-content {
  padding: 30px;
}

.intro-text {
  margin-bottom: 20px;
  line-height: 1.6;
  color: #333;
  font-size: 15px;
}

.form-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 16px;
    line-height: 1.8;
    padding: 12px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border-left: 3px solid #0060af;

    strong {
      color: #000;
      margin-right: 8px;
      display: inline-block;
      min-width: 200px;
    }

    a {
      margin: 0 4px;
    }
  }
}

.pdf-link {
  color: #0060af;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    text-decoration: underline;
    color: #004a8a;
  }
}

.submit-btn {
  min-width: 200px;
  text-transform: none;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.helper-text {
  color: #666;
  font-size: 14px;
  font-style: italic;
}

// Remove default prepend icon slot
::v-deep .v-input__prepend-outer {
  display: none !important;
}
</style>